<div class="help-support-section" [ngClass]="isStandalonePage ? 'opacity' : ''">
  <!-- Footer Header - Only shown when opened in new tab -->
  <app-footer-header *ngIf="isStandalonePage"></app-footer-header>

  <!-- Hero Section with Animated Background -->
  <div class="hero-section">


    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          <span class="title-line">Help & <span class="highlight">Support</span></span>
        </h1>
        <p class="hero-subtitle">Everything you need to manage your policy with ease</p>
      </div>

      <!-- Enhanced Search with Floating Design -->
      <div class="search-container">
        <div class="search-box">
          <div class="search-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <input type="text" placeholder="Search for help topics..." class="search-input">
          <button class="search-btn">
            <span>Search</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M12 5L19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Support Categories with Modern Cards -->
  <div class="support-categories">
    <div class="category-grid-container">


      <div class="category-grid">
        <!-- Original Cards Set 1 -->
        <div class="support-card payment-card" data-category="payments">
          <div class="top-right-curve-1"></div>
          <div class="top-right-curve-2"></div>
          <div class="top-right-curve-3"></div>
          <div class="card-logo">
            <img src="../../../../../../assets/images/credit-card.svg" alt="Payment Logo" width="80" height="80">
          </div>
          <div class="card-content">
            <h3 class="card-name">Payment Services</h3>
            <p class="card-title">Change card or bank details</p>
            <div class="card-text">
              <span class="quote-mark">"</span>
              Easily update your payment methods and manage your billing preferences with our secure payment portal.
            </div>
          </div>
        </div>

        <div class="support-card beneficiary-card" data-category="beneficiary">
          <div class="top-right-curve-1"></div>
          <div class="top-right-curve-2"></div>
          <div class="top-right-curve-3"></div>
          <div class="card-logo">
            <img src="../../../../../../assets/images/family.svg" alt="Payment Logo" width="80" height="80">

          </div>
          <div class="card-content">
            <h3 class="card-name">Beneficiary Management</h3>
            <p class="card-title">Update beneficiary details</p>
            <div class="card-text">
              <span class="quote-mark">"</span>
              Keep your beneficiary information current and ensure your loved ones are properly protected.
            </div>
          </div>
        </div>

        <div class="support-card details-card" data-category="details">
          <div class="top-right-curve-1"></div>
          <div class="top-right-curve-2"></div>
          <div class="top-right-curve-3"></div>
          <div class="card-logo">
            <img src="../../../../../../assets/images/files.svg" alt="Payment Logo" width="80" height="80">

          </div>
          <div class="card-content">
            <h3 class="card-name">Personal Information</h3>
            <p class="card-title">Change address or contact details</p>
            <div class="card-text">
              <span class="quote-mark">"</span>
              Update your personal information to ensure we can reach you and provide the best service.
            </div>
          </div>
        </div>

        <div class="support-card documents-card" data-category="documents">
          <div class="top-right-curve-1"></div>
          <div class="top-right-curve-2"></div>
          <div class="top-right-curve-3"></div>
          <div class="card-logo">
            <img src="../../../../../../assets/images/documents.svg" alt="Payment Logo" width="80" height="80">

          </div>
          <div class="card-content">
            <h3 class="card-name">Document Center</h3>
            <p class="card-title">View your policy documents</p>
            <div class="card-text">
              <span class="quote-mark">"</span>
              Access all your important policy documents and certificates in one secure location.
            </div>
          </div>
        </div>

        <div class="support-card adviser-card" data-category="adviser">
          <div class="top-right-curve-1"></div>
          <div class="top-right-curve-2"></div>
          <div class="top-right-curve-3"></div>
          <div class="card-logo">
            <img src="../../../../../../assets/images/email.svg" alt="Payment Logo" width="80" height="80">

          </div>
          <div class="card-content">
            <h3 class="card-name">Adviser Contact</h3>
            <p class="card-title">Have a query about your policy</p>
            <div class="card-text">
              <span class="quote-mark">"</span>
              Get in touch with your dedicated adviser for personalized support and guidance.
            </div>
          </div>
        </div>

        <div class="support-card claims-card" data-category="claims">
          <div class="top-right-curve-1"></div>
          <div class="top-right-curve-2"></div>
          <div class="top-right-curve-3"></div>
          <div class="card-logo">
            <img src="../../../../../../assets/images/claims.svg" alt="Payment Logo" width="80" height="80">

          </div>
          <div class="card-content">
            <h3 class="card-name">Claims Support</h3>
            <p class="card-title">Start the claims process</p>
            <div class="card-text">
              <span class="quote-mark">"</span>
              Begin your claims journey with our streamlined process and expert support team.
            </div>
          </div>
        </div>


      </div>

      <!-- Navigation Controls -->
      <div class="navigation-controls">

        <div class="scroll-dots">
          <div *ngFor="let card of uniqueCards; let i = index" class="dot" [class.active]="i === currentCardIndex"
            (click)="scrollToCard(i)">
          </div>
        </div>

      </div>

    </div>
  </div>

  <app-footer *ngIf="isStandalonePage"></app-footer>


</div>